/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TalentPoolUpdateRequestColor = typeof TalentPoolUpdateRequestColor[keyof typeof TalentPoolUpdateRequestColor] | null;


export const TalentPoolUpdateRequestColor = {
  gray: 'gray',
  red: 'red',
  orange: 'orange',
  amber: 'amber',
  yellow: 'yellow',
  green: 'green',
  teal: 'teal',
  cyan: 'cyan',
  blue: 'blue',
  indigo: 'indigo',
  violet: 'violet',
  pink: 'pink',
} as const;
